import {useState} from 'react'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import {KTIcon} from '../../../helpers'
import {useUserStateProvider} from '../../../../app/utils/contextProvider/UserStateProvider'

const KeyContactDetails = () => {
  const {loadingMenu} = useUserStateProvider()

  const [show, setShow] = useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  if (loadingMenu) return <></>

  return (
    <>
      <Button
        variant='outline'
        onClick={handleShow}
        className='bg-transparent p-1 align-self-center d-flex align-items-center border-0'
      >
        <KTIcon iconName='user-tick' className='fs-2hx fs-md-2x' />
        <span className='d-none d-md-inline fs-4 fw-bold me-4'>Key Contact Details</span>
      </Button>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Key Contact Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>Woohoo, you are reading this text in a modal!</Modal.Body>
        {/* <Modal.Footer>
          <Button variant='secondary' onClick={handleClose}>
            Close
          </Button>
          <Button variant='primary' onClick={handleClose}>
            Save Changes
          </Button>
        </Modal.Footer> */}
      </Modal>
    </>
  )
}

export default KeyContactDetails
